import { solarMachine } from '~/machines/solar-funnel';
import { uploadMachine } from '~/machines/upload';
import { signUpUser } from '~/services';
import { getInitialState } from '~/utils/funnels';
import { goSolarFunnelRedirects } from '~/utils/redirects';
import { sendToSegment } from '~/utils/tracking';
import { config } from './config';

export const funnelMachine = () =>
  solarMachine({
    id: config.id,
    initialState: getInitialState(config.id, solarMachine),
    utility: {
      context: { redirect: goSolarFunnelRedirects },
    },
    user: {
      context: { requirePhone: true, showInviteCode: true },
    },
  }).withConfig({
    services: {
      uploadMachine: uploadMachine().withConfig({
        actions: {
          trackCompleted: emitSegmentEvents,
        },
      }),
      signUpUser: async context => {
        const { plan } = await signUpUser({
          utilityAccountId: context.funnelPacket!.utilityAccount.id,
          planId: context.funnelPacket!.customPlan.id,
          enrollmentDataSourceName:
            context.enrollmentSelection! ||
            context.funnelPacket!.utilityAccount.enrollmentDataSourceName ||
            'none',
          billingExperienceType: context.billingSelection! || 'none',
          track: context.funnelTrack || context.funnelPacket!.utility.funnelTrack,
          funnelVnmProjectId:
            context.queryParams.projectId! ||
            context.queryParams.unparsedQueryParams?.projectId! ||
            context.funnelPacket?.funnelVnmProjectId!,
        });
        return { planId: plan.id };
      },
    },
  });

export const emitSegmentEvents = (context, event) => {
  /* eslint-disable camelcase */
  if (event.type === 'SUBMIT_DOCS') {
    const docSelected = context.docs[0].documentType;
    sendToSegment({
      type: 'lmi_document_upload',
      funnelPacket: context?.funnelPacket,
      additional: {
        selected_function: docSelected,
      },
    });
  } else {
    sendToSegment({
      type: 'lmi_document_skipped',
      funnelPacket: context?.funnelPacket,
    });
  }
  /* eslint-enable camelcase */
  sendToSegment({
    type: 'upload_lmi_proof_docs_step_completed',
    funnelPacket: context.funnelPacket,
    documentTypes: context.docs.map(doc => doc.documentType),
  });
};
